import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ConsultationWrapper = ({ children }) => {
    const { isAuthenticated, loading, user } = useAuth();
    const location = useLocation();

    // Show loading spinner while checking authentication
    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f8f9fa'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <i className="fa fa-spinner fa-spin" style={{ fontSize: '32px', color: '#62B6E8' }}></i>
                    <p style={{ marginTop: '16px', color: '#666' }}>Loading...</p>
                </div>
            </div>
        );
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated) {
        const redirect = `${location.pathname}${location.search || ''}`;
        return <Navigate to={`/user-login?redirect=${encodeURIComponent(redirect)}`} state={{ from: location }} replace />;
    }

    // Prevent admins from accessing consultation form
    if (user?.role === 'admin' || user?.role === 'editor' || user?.role === 'viewer') {
        return <Navigate to="/admin/dashboard" replace />;
    }

    return <>{children}</>;
};

export default ConsultationWrapper;
